import * as PIXI from "pixi.js";
import gsap from "gsap";

import { Signal } from "signals";
import ServiceLocator from "../../ServiceLocator";
import Card from "./Card";
import Utils from "../../Utils";


export default class DeckCreationAnimation
{
    private _arrDeckCard: Array<Card> = null;
    private _deckShadow: PIXI.Container = null;

    private _tl: gsap.core.Timeline = null;

    private _onCompleted: Signal = null;


    public set deck( value: Array<Card> ) { this._arrDeckCard = value; }
    public set deckShadow( value: PIXI.Container ) { this._deckShadow = value; }

    public get onCompleted(): Signal { return this._onCompleted; }


    public constructor() {}

    public init(): void
    {
        console.assert( this._arrDeckCard != null, "DeckCreationAnimation.ts :: init() :: this._arrDeckCard cannot be null." );

        this._onCompleted = new Signal();
    }

    public end(): void
    {
        this._onCompleted.dispose();
        this._onCompleted = null;

        if ( this._tl )
        {
            this._tl.kill();
            this._tl = null;
        }
    }

    public play(): void
    {
        ServiceLocator.audio.playSfx( "shuffle_" + Utils.randomInteger( 0, 2 ).toString() );

        this._tl = new gsap.core.Timeline();

        let time: number = 0;
        let cardIndex: number = 0;
        for ( let card of this._arrDeckCard )
        {
            card.alpha = 0;
            card.x -= 50;
            card.y -= 100;

            this._deckShadow.children[ cardIndex ].visible = false;
            cardIndex += 1;
        }

        for ( let i: number = 0; i <= this._arrDeckCard.length - 1; ++i )
        {
            this._tl.to( this._arrDeckCard[ i ], { x: "+=50", y: "+=100", alpha: 1, duration: 0.02, ease: "sine.out" }, time );
            this._tl.call( ( cardIndex: number ) => { this._deckShadow.children[ cardIndex ].visible = true; }, [ i ], ">" );

            if ( i % 2 == 0 )
            {
                time += 0.01;
            }
        }

        this._tl.call( () => { 
            this._onCompleted.dispatch(); 
        }, null, ">" );
        //
        ServiceLocator.game.tweenGroup.add( this._tl );
    }

    public calcDuration(): number
    {
        return this._arrDeckCard.length * 0.01 + 0.02;
    }
}